module.exports = __webpack_public_path__ + "static/img/image_article_010.a5525ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/article_img/image_article_010.png
// module id = /rpu
// module chunks = 0